import React, { useRef, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useTranslation } from "react-i18next";

function TrustedCompanies() {
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const [t, i18n] = useTranslation("global");
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    const fetchCompanies = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/companies`, {
          headers: {
            "Accept-Language": i18n.language,
          },
        });
        const result = await response.json();
        setCompanies(result?.data || []);
      } catch (error) {
        console.error("Error fetching companies:", error);
      }
    };

    fetchCompanies();
  }, [i18n.language]);

  return (
    <section className="container py-5">
      <h1 className="main-color text-center mb-3">{t("ourInstructors.trust")}</h1>

      <div
        className="position-relative"
        style={{ maxWidth: "800px", margin: "0 auto" }}
      >
        <Swiper
          modules={[Navigation, Autoplay]}
          onSwiper={(swiper) => {
            if (prevRef.current && nextRef.current) {
              swiper.params.navigation.prevEl = prevRef.current;
              swiper.params.navigation.nextEl = nextRef.current;
              swiper.navigation.init();
              swiper.navigation.update();
            }
          }}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
          }}
          spaceBetween={5}
          slidesPerView={5}
          breakpoints={{
            1200: { slidesPerView: 6 },
            992: { slidesPerView: 4 },
            768: { slidesPerView: 3 },
            576: { slidesPerView: 2 },
            425: { slidesPerView: 2 },
            375: { slidesPerView: 2 },
            325: { slidesPerView: 2 },
          }}
          className="myUniqueSwiper"
          style={{ width: "800px" }}
        >
          {companies.map((company, index) => (
            <SwiperSlide
              key={index}
              style={{ display: "flex", justifyContent: "center" }}
            >
              <img
                src={company.image}
                alt="Company Logo"
                className="custom-rounded-img"
                style={{
                  borderRadius: "50%",
                  width: "80px",
                  maxWidth: "100%",
                  height: "80px",
                  objectFit: "cover",
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
}

export default TrustedCompanies;
